import { acceptOnlyValidProducts } from '../product-list/product-list-normalize-value';
export const donationViewer = {
    normalizeLoadedValue: acceptOnlyValidProducts
};

//# sourceMappingURL=definition-viewer.js.map